/* import __COLOCATED_TEMPLATE__ from './segment-with-tooltip.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();